import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EMenuActionType {
  Open = 'menu/open',
  Close = 'menu/close',
}

export type TOpenMenu = ITypedReduxAction<EMenuActionType.Open>;
export type TCloseMenu = ITypedReduxAction<EMenuActionType.Close>;

export type TMenuActions = TOpenMenu | TCloseMenu;
